// extracted by mini-css-extract-plugin
module.exports = {"loader":"PageOverlayLoader_loader__1arrB","loaderOuter":"PageOverlayLoader_loaderOuter__1UUiH"};